var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".75em",
    height: "1em",
    viewBox: "0 0 24 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 30.5h14H2Z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.971
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.214 8.023h8.366M5.214 14.196h12.118M5.214 20.369h12.118M22.384 9.967v18.505c0 .943-.771 1.714-1.714 1.714H2.7a1.72 1.72 0 0 1-1.714-1.714V2.7A1.72 1.72 0 0 1 2.7.985h11.057l8.627 8.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.756.986v9.173h8.627"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export default ForwardRef;